import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=f33489e2&scoped=true&lang=pug&"
import script from "./wallet.vue?vue&type=script&lang=ts&"
export * from "./wallet.vue?vue&type=script&lang=ts&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=f33489e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33489e2",
  null
  
)

export default component.exports